import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { TextInputProps } from 'react-native';

import TextInputBase, { TextFieldType } from './TextInputBase';

export type TextInputFieldProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  placeholder: string;
  currency?: boolean;
  type?: TextFieldType;
  hideError?: boolean;
  leadingIcon?: React.ReactNode;
  traillingIcon?: React.ReactNode;
  variant?: 'default' | 'rounded_with_shadow' | 'small_border_radius' | 'gray_borders' | 'chat';
  label?: string;
  autoCapitalize?: TextInputProps['autoCapitalize'];
  maxLength?: TextInputProps['maxLength'];
  multiline?: TextInputProps['multiline'];
  minHeight?: number;
  maxHeight?: number;
  onEndEditing?: TextInputProps['onEndEditing'];
  onSubmitEditing?: TextInputProps['onSubmitEditing'];
  onKeyPress?: TextInputProps['onKeyPress'];
  returnKeyLabel?: TextInputProps['returnKeyLabel'];
  returnKeyType?: TextInputProps['returnKeyType'];
  textContentType?: TextInputProps['textContentType'];
  editable?: TextInputProps['editable'];
  onChangeCallback?: (data: string) => void;
  infoToolTip?: string;
  infoSubLabel?: string;
};

const TextInputField = <T extends FieldValues>(props: TextInputFieldProps<T>) => {
  const { control, name, ...restProps } = props;

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: true
      }}
      render={({ field: { onChange, value, onBlur, ref }, fieldState: { error } }) => (
        <TextInputBase
          refCallback={ref}
          value={value}
          onChangeCallback={(data) => {
            onChange(data);
            restProps.onChangeCallback && restProps.onChangeCallback(data);
          }}
          onBlur={onBlur}
          error={error?.message}
          {...restProps}
        />
      )}
    />
  );
};

export default TextInputField;
